import Proxy from "./Proxy"

class ProductContractProxy extends Proxy {
  constructor(parameters = {}) {
    super("product-contracts", parameters)
  }
}

export default ProductContractProxy
